import axios from "axios";

export default function getCommissionNoHook(data, jwt) {
    return new Promise((resolve, reject) => {
        const backend_url = process.env.REACT_APP_BACKEND_URL;
        let target = `${backend_url}/commission-structures/`;

        axios({
            url: target + data.id,
            method: "GET",
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        })
            .then((res) =>
                resolve({
                    data: res.data,
                    error: false,
                    complete: true,
                })
            )
            .catch((e) => {
                reject({
                    data: null,
                    error: true,
                    errorMessage: e.response.data,
                    complete: true,
                });
            });
    });
}
